import React from "react";
import { Box, Typography } from "@mui/material";
import { MONTHS } from "../catalog-planner/utils";
import { fmtUnits } from "./ForecastGrid";

const BUY_MONTHS = 3;

/**
 * A SKU's buy recommendation for the first three forecast months, straight
 * from the run's roll-up — nothing is fetched. Plan forecasts have no insight
 * or inventory ledger.
 */
export default function SkuDetail({ sku, closed, darkMode }) {
  const border = darkMode ? "#333" : "#e0e0e0";
  const textSec = darkMode ? "#aaa" : "#666";

  // First three forecast months of the plan year.
  const buyMonths = [];
  for (let i = closed; i < 12 && buyMonths.length < BUY_MONTHS; i++) {
    buyMonths.push({ month: MONTHS[i], units: sku.forecast_units?.[i] });
  }
  const stat = (label, value) => (
    <Box key={label} sx={{ minWidth: 110 }}>
      <Typography sx={{ fontSize: 10, color: textSec, textTransform: "uppercase", letterSpacing: 0.4 }}>{label}</Typography>
      <Typography sx={{ fontSize: 15, fontWeight: 600 }}>{value}</Typography>
    </Box>
  );

  return (
    <Box sx={{ border: `1px solid ${border}`, borderRadius: 1, p: 1.5, mt: 1 }}>
      <Typography sx={{ fontSize: 12, fontWeight: 700, mb: 0.75 }}>Buy recommendation · next {BUY_MONTHS} months</Typography>
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2.5 }}>
        {buyMonths.map((m) => stat(`Forecast ${m.month}`, fmtUnits(m.units)))}
        {stat("On hand", fmtUnits(sku.on_hand))}
        {stat("Reorder point", fmtUnits(sku.reorder_point))}
        {stat("Recommended order", fmtUnits(sku.recommended_order_qty))}
        {sku.list_price ? stat("List price", `$${sku.list_price}`) : null}
      </Box>
    </Box>
  );
}
